<template>
    <div>
        <ModalMessage
            :visible="showSuccessMessage"
            :title="successTitle"
            :messages="successMessages"
            @close="showSuccessMessage = false"
        />
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>
        <div class="p-6 pb-0">



            <PageServerTable :headers="headers" :items="items" :items-per-page.sync="ipp" :items-per-page-options="ippo"
                :sort-by="sortby" :items-length="count" :reload-fn="reload" v-model.selected="selected"
                :item-value="'Item'" :page="page" show-current-page
                :row-props="({ item }) => item.activities_count > 0 ? { class: 'row-has-activities' } : {}">
                <template #item.Item="{ item }">
                    <span>'{{ item.Item }}'</span>
                </template>
                <template #item.select="{ item }">
                    <Link :href="route('modules.attivita.gestione-ordine', item.SaleOrdId)"
                        class="p93__btn_primary inline-block px-2 py-1 text-xs">
                        {{ $t('at.actions.generate_activities') }}
                    </Link>
                </template>
                <template #item.OrderDate="{ item }"> <span> {{ formatDate(item.OrderDate) }} </span> </template>
                <template #item.ExpectedDeliveryDate="{ item }"> <span> {{ formatDate(item.ExpectedDeliveryDate) }} </span> </template>
            </PageServerTable>
        </div>


    </div>

</template>

<script>
import { Link, router } from '@inertiajs/vue3';
import PageServerTable from '@/Components/PageServerTable.vue';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import ModalMessage from '@/Components/ModalMessage.vue';

export default {
    props: ['errors', 'items', 'count', 'ippo'],
    components: {
        Link,
        PageServerTable,
        BreadCrumbs,
        ModalMessage
    },
    data() {
        return {
            search: this.filters?.search || "",
            inventoryrows: [],
            selected: [],
            headers: [],
            sortby: [],
            ipp: 10,
            page: 1,
            showSuccessMessage: false,
            successTitle: '',
            successMessages: [],
        };
    },
    computed: {
        navigation() {
            return [
                { name: this.$t('ui.dashboard'), href: route('dashboard') },
                { name: this.$t('modules.attivita'), href: route('modules.home', 'attivita') },
                { name: this.$t('at.breadcrumb.lista_ordini'), href: route('modules.attivita.lista-ordini') }
            ];
        }
    },
    methods: {
        reload(sortby = undefined, itemsperpage = undefined, page = undefined) {

            if (sortby) this.sortby = sortby;
            if (itemsperpage) this.ipp = itemsperpage;
            if (page) this.page = page;

            router.post(window.location.href, { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page }, { only: ['items', 'count']});
        },



    },
    mounted() {
        this.headers = this.$attrs.headers;
        this.ipp = this.$attrs.ipp;
        this.page = this.$attrs.page;
        this.sortby = this.$attrs.sortby;
    }
};
</script>

<style>
.row-has-activities td {
    background-color: #dcfce7 !important;
}
</style>